"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TypesenseError_1 = tslib_1.__importDefault(require("./TypesenseError"));
var RequestUnauthorized = /** @class */ (function (_super) {
    tslib_1.__extends(RequestUnauthorized, _super);
    function RequestUnauthorized() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RequestUnauthorized;
}(TypesenseError_1.default));
exports.default = RequestUnauthorized;
//# sourceMappingURL=RequestUnauthorized.js.map